type OfficeSearchState =
  | "idle"
  | "loading"
  | "error"
  | "no-offices"
  | "has-offices";

type GetOfficeSearchStateParams = {
  franchiseOptionsCount: number;
  hasSearchError: boolean;
  isFetching: boolean;
  isPostalCodeValid: boolean;
};

function getOfficeSearchState({
  franchiseOptionsCount,
  hasSearchError,
  isFetching,
  isPostalCodeValid,
}: GetOfficeSearchStateParams): OfficeSearchState {
  if (!isPostalCodeValid) {
    return "idle";
  }

  if (isFetching) {
    return "loading";
  }

  if (hasSearchError) {
    return "error";
  }

  if (franchiseOptionsCount === 0) {
    return "no-offices";
  }

  return "has-offices";
}

export type { OfficeSearchState };

export { getOfficeSearchState };
